(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arb-about"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hero = document.querySelector('[data-arb-forest]');
    if (!hero || hero.dataset.ready) return;
    hero.dataset.ready = '1';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const leafBox = hero.querySelector('.arb-about__leaves');
    const leafSvg = '<svg viewBox="0 0 10 16"><path fill="currentColor" d="M5 16C9 11 9 5 5 0 1 5 1 11 5 16z"/></svg>';
    if (!reduce && leafBox) {
      for (let i = 0; i < 14; i++) {
        const el = document.createElement('span');
        el.className = 'arb-about__leaf';
        el.innerHTML = leafSvg;
        el.style.left = Math.random() * 100 + '%';
        el.style.setProperty('--s', 8 + Math.random() * 12 + 'px');
        el.style.setProperty('--t', 12 + Math.random() * 14 + 's');
        el.style.setProperty('--delay', -Math.random() * 20 + 's');
        el.style.setProperty('--sway', (Math.random() * 160 - 80).toFixed(0) + 'px');
        leafBox.appendChild(el);
      }
    }

    const canvas = hero.querySelector('.arb-about__pollen');
    if (!canvas || reduce) return;
    const ctx = canvas.getContext('2d');
    let w, h, dots, raf;
    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.width = hero.clientWidth * dpr;
      h = canvas.height = hero.clientHeight * dpr;
      dots = Array.from({ length: Math.round((hero.clientWidth * hero.clientHeight) / 14000) }, () => ({
        x: Math.random() * w,
        y: Math.random() * h,
        r: (Math.random() * 1.6 + 0.4) * dpr,
        vx: (Math.random() - 0.5) * 0.15 * dpr,
        vy: (-Math.random() * 0.25 - 0.05) * dpr,
        p: Math.random() * Math.PI * 2,
      }));
    };
    const draw = (t) => {
      ctx.clearRect(0, 0, w, h);
      for (const d of dots) {
        d.x += d.vx + Math.sin(t / 2400 + d.p) * 0.12;
        d.y += d.vy;
        if (d.y < -10) { d.y = h + 10; d.x = Math.random() * w; }
        const a = 0.25 + 0.35 * (0.5 + 0.5 * Math.sin(t / 900 + d.p));
        ctx.beginPath();
        ctx.fillStyle = `rgba(214, 190, 140, ${a})`;
        ctx.arc(d.x, d.y, d.r, 0, Math.PI * 2);
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    };
    resize();
    window.addEventListener('resize', resize);
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) raf = requestAnimationFrame(draw);
      else cancelAnimationFrame(raf);
    });
    io.observe(hero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arb-manifesto"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('arb-word-reveal')) {
    customElements.define(
      'arb-word-reveal',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready) return;
          this.dataset.ready = '1';
          const words = this.textContent.trim().split(/\s+/);
          this.textContent = '';
          words.forEach((w, i) => {
            const s = document.createElement('span');
            s.className = 'arb-w';
            s.style.setProperty('--i', i);
            s.textContent = w;
            this.append(s, i < words.length - 1 ? ' ' : '');
          });
          const io = new IntersectionObserver(
            (entries) => {
              if (entries[0].isIntersecting) {
                this.classList.add('is-in');
                io.disconnect();
              }
            },
            { threshold: 0.4 }
          );
          io.observe(this);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arb-materials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('arb-panels')) {
    customElements.define(
      'arb-panels',
      class extends HTMLElement {
        connectedCallback() {
          this.panels = [...this.querySelectorAll('.arb-mat__panel')];
          const open = (p) => this.panels.forEach((x) => x.classList.toggle('is-open', x === p));
          this.panels.forEach((p) => {
            p.addEventListener('mouseenter', () => window.matchMedia('(hover: hover)').matches && open(p));
            p.addEventListener('focus', () => open(p));
            p.addEventListener('click', (e) => {
              if (!p.classList.contains('is-open')) {
                e.preventDefault();
                open(p);
              }
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arb-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('arb-count-up')) {
    customElements.define(
      'arb-count-up',
      class extends HTMLElement {
        connectedCallback() {
          const target = parseFloat(this.dataset.to) || 0;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || target === 0) return;
          const fmt = new Intl.NumberFormat(document.documentElement.lang || 'tr');
          this.textContent = '0';
          const io = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) return;
            io.disconnect();
            const start = performance.now();
            const dur = 1600;
            const tick = (now) => {
              const t = Math.min((now - start) / dur, 1);
              const eased = 1 - Math.pow(1 - t, 4);
              this.textContent = fmt.format(Math.round(target * eased));
              if (t < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          });
          io.observe(this);
        }
      }
    );
  }

  if (!customElements.get('arb-quote-rotator')) {
    customElements.define(
      'arb-quote-rotator',
      class extends HTMLElement {
        connectedCallback() {
          this.items = [...this.querySelectorAll('.arb-proof__quote')];
          this.dots = [...this.querySelectorAll('.arb-proof__dot')];
          this.index = 0;
          this.dots.forEach((d) => d.addEventListener('click', () => this.show(+d.dataset.index, true)));
          if (this.items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.start();
          this.addEventListener('mouseenter', () => clearInterval(this.timer));
          this.addEventListener('mouseleave', () => this.start());
        }
        start() {
          clearInterval(this.timer);
          this.timer = setInterval(() => this.show((this.index + 1) % this.items.length), +this.dataset.interval || 6000);
        }
        show(i, user) {
          this.index = i;
          this.items.forEach((q, n) => {
            q.classList.toggle('is-active', n === i);
            q.setAttribute('aria-hidden', n === i ? 'false' : 'true');
          });
          this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
          if (user) this.start();
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arb-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('arb-sticky-atc')) {
    customElements.define(
      'arb-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          // The installments form also posts to /cart/add but has no button, so pick the form that has one.
          this.form = [...document.querySelectorAll('product-info form[action$="/cart/add"], form.product-form[action$="/cart/add"], form[id^="product-form-template"]')].find((f) => f.querySelector('[type="submit"]'));
          this.mainBtn = this.form && this.form.querySelector('[type="submit"]');
          this.btn = this.querySelector('[data-arb-sticky-btn]');
          this.priceEl = this.querySelector('[data-arb-sticky-price]');
          if (!this.form || !this.mainBtn) return;

          const io = new IntersectionObserver(([entry]) => {
            // Show whenever the main button is off screen, so phones see a buy button before scrolling to it.
            const passed = !entry.isIntersecting;
            this.classList.toggle('is-visible', passed);
            this.setAttribute('aria-hidden', passed ? 'false' : 'true');
            this.btn.tabIndex = passed ? 0 : -1;
          });
          io.observe(this.mainBtn);

          this.btn.addEventListener('click', () => {
            if (this.mainBtn.disabled) return;
            this.mainBtn.click();
          });

          const sync = () => {
            this.btn.disabled = this.mainBtn.disabled;
            this.btn.textContent = this.mainBtn.textContent.trim();
            const price = document.querySelector('[id^="price-"] .price-item--last, [id^="price-"] .price-item--regular');
            if (price && this.priceEl) this.priceEl.textContent = price.textContent.trim();
          };
          new MutationObserver(sync).observe(this.mainBtn, { attributes: true, childList: true, subtree: true });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arb-trust-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('arb-count-up')) {
    customElements.define(
      'arb-count-up',
      class extends HTMLElement {
        connectedCallback() {
          const target = parseFloat(this.dataset.to) || 0;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || target === 0) return;
          const fmt = new Intl.NumberFormat(document.documentElement.lang || 'tr');
          this.textContent = '0';
          const io = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) return;
            io.disconnect();
            const start = performance.now();
            const dur = 1600;
            const tick = (now) => {
              const t = Math.min((now - start) / dur, 1);
              this.textContent = fmt.format(Math.round(target * (1 - Math.pow(1 - t, 4))));
              if (t < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          });
          io.observe(this);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arb-ugc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('arb-drag-scroll')) {
    customElements.define(
      'arb-drag-scroll',
      class extends HTMLElement {
        connectedCallback() {
          let startX = 0;
          let startScroll = 0;
          let moved = false;
          const down = (e) => {
            if (e.pointerType !== 'mouse') return;
            startX = e.clientX;
            startScroll = this.scrollLeft;
            moved = false;
            this.setPointerCapture(e.pointerId);
            this.addEventListener('pointermove', move);
          };
          const move = (e) => {
            const dx = e.clientX - startX;
            if (Math.abs(dx) > 4) {
              moved = true;
              this.classList.add('is-dragging');
            }
            this.scrollLeft = startScroll - dx;
          };
          const up = (e) => {
            this.removeEventListener('pointermove', move);
            if (this.hasPointerCapture(e.pointerId)) this.releasePointerCapture(e.pointerId);
            requestAnimationFrame(() => this.classList.remove('is-dragging'));
          };
          this.addEventListener('pointerdown', down);
          this.addEventListener('pointerup', up);
          this.addEventListener('pointercancel', up);
          this.addEventListener(
            'click',
            (e) => {
              if (moved) {
                e.preventDefault();
                moved = false;
              }
            },
            true
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arb-wishlist"]) return;
  try {
    
  if (!customElements.get('arb-wishlist-page')) {
    customElements.define(
      'arb-wishlist-page',
      class extends HTMLElement {
        connectedCallback() {
          this.grid = this.querySelector('[data-arb-wl-grid]');
          this.empty = this.querySelector('[data-arb-wl-empty]');
          this.money = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' });
          this.onChange = () => this.render();
          document.addEventListener('arb:wishlist', this.onChange);
          const start = () => this.render();
          if (window.arbWishlist) start();
          else window.addEventListener('DOMContentLoaded', start, { once: true });
        }

        disconnectedCallback() {
          document.removeEventListener('arb:wishlist', this.onChange);
        }

        async render() {
          const handles = window.arbWishlist ? window.arbWishlist.list() : [];
          const products = (
            await Promise.all(
              handles.map((h) =>
                fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(h)}.js`)
                  .then((r) => (r.ok ? r.json() : null))
                  .catch(() => null)
              )
            )
          ).filter(Boolean);

          this.empty.hidden = products.length > 0;
          this.grid.hidden = products.length === 0;
          this.grid.replaceChildren(...products.map((p) => this.card(p)));
        }

        card(p) {
          const li = document.createElement('li');
          li.className = 'arb-wl__item';
          const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=600` : '';
          const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
          li.innerHTML = `
            <a class="arb-wl__media" href="${esc(p.url)}">${img ? `<img src="${esc(img)}" alt="${esc(p.title)}" loading="lazy" width="600" height="750">` : ''}</a>
            <a class="arb-wl__name" href="${esc(p.url)}">${esc(p.title)}</a>
            <p class="arb-wl__price">${p.available ? this.money.format(p.price / 100) : esc(this.dataset.soldOut)}</p>
            <div class="arb-wl__actions">
              <a href="${esc(p.url)}">${esc(this.dataset.view)}</a>
              <button type="button">${esc(this.dataset.remove)}</button>
            </div>`;
          li.querySelector('button').addEventListener('click', () => window.arbWishlist.remove(p.handle));
          return li;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
